<template>
    <ui-sidebar-float
        :load="optionsLoading"
        :loadText="loadText"
        name="edit-contract-generation"
        title="Editar Contrato"
        text="Informe os dados para edição do contrato."
        :overlay-close="false"
    >
        <form :id="formName" class="content">
            <div class="sidebar-content">
                <div v-if="mensage" class="erro-mensage">
                {{ mensage }}
                </div>
                <ui-input
                    v-model="form.data.name"
                    type="text"
                    label="Descrição do Contrato:"
                    :class="this.form.errors.name"
                    size="md"
                />

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.products"
                        label="Selecione os Empreendimentos:"
                        :loading="groupFieldLoading"
                        :data="options.products"
                        return-value="value"
                        multiple
                    />
                </div>

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.stage"
                        label="Selecione as Etapas:"
                        :loading="groupFieldLoading"
                        :data="options.stage"
                        return-value="value"
                        group-by="type"
                        item-label="label"
                        multiple
                        @input="stageInputHandler"
                    />
                </div>

                <div class="select-area">
                    <ui-select-2 
                        v-model="form.data.visibility.status"
                        label="Selecione as Status:"
                        :loading="statusLoading"
                        :data="options.status"
                        return-value="value"
                        group-by="type"
                        item-label="label"
                        multiple
                    />
                </div>

                <ui-input
                    v-model="form.data.empty"
                    type="text"
                    :class="this.form.errors.empty"
                    label="Substituir campos vazios por:"
                    size="md"
                />
                <span class="contract-label">Contrato Anexado:</span>
                <div v-if="file_name" class="contract-file-name">
                    <em class="fal fa-file-alt"></em>
                    {{file_name}}
                </div>
            </div>
            <div class="sidebar-content">
                <uiUploadFiles
                    :id="'sidebar-edit-upload' + componentID  "
                    @input="fileUpload"
                    label="Alterar Documento Word:"
                    helpText="* Somente arquivos: .doc, .docx"
                    size="md"
                >
                </uiUploadFiles>
            </div>
        </form>
        <template #footer>
            <ui-button
                type="button"
                :design="`lg success block`"
                @click="submitForm"
                :disabled="!canSubmit"
                >Salvar Contrato</ui-button
            >
        </template>
    </ui-sidebar-float>
</template>

<script>
import { product, funnel, files, contractGeneration } from '@/services/axios'
import { uiSidebarFloat, uiUploadFiles } from '@/components/ui'
import { uiInput, uiSelect2 } from "@/components/ui/form"
import { uiButton } from '@/components/ui/buttons'

import { sidebarDefaultReset } from './methods'
import { canSubmit } from './computed'

// Queridos colegas de trabalho, apenas editei esse componente, não sintam raiva de mim.

/**
 * Objeto com os dados padrões do formulario 
 * Utilize para limpar o formulario
 */
const defaultFormData = function () {
    return {
        id: null,
        name: '',
        errors: { name: '', products: '', stage: '', status: '', empty: '' },
        data: {
            name: '',
            file_id: 0,
            empty: '',
            permissions: '',
            data: '',
            visibility: {
                products: [],
                stage: [],
                status: []
            }
        },
        custom_fields: {},
        extra_fields: {
            deal: {
                funnel_stage_id: null,
                funnel_stage_status_id: null,
                product_id: null
            }
        }
    }
}

const getFileExtension = function(files){
    let extension = files.file
    extension = extension.substr(extension.indexOf('.'))
    return files.name.replace(/(.$)/g,"") + extension
}

const defaultOptionsArray = () => ({
    products: [],
    stage: [],
    status: [],
})

export default {
    components: {
        uiButton,
        uiSidebarFloat,
        uiInput,
        uiSelect2,
        uiUploadFiles
    },
    data() {
        return {
            searchInputValue: "",
            formName: 'form-sidebar-' + this._uid,
            componentID: this._uid,
            form: { ...defaultFormData() },
            mensage: '',
            options: { ...defaultOptionsArray() },
            optionsLoading: false,
            productLoading: false,
            stageLoading: false,
            statusLoading: false,
            funnelStageOptions: [],
            funnelStageLoading: false,
            fileUploadLoading: false,
            fieldGroupOptions: [],
            fieldGroupSelected: null,
            fieldGroupLoading: false,
            groupFieldOptions: [],
            groupFieldLoading: false,
            groupFieldSelected: null,
            leadOptions: [],
            leadLoading: false,
            unsubscribe: null,
            loadText: null,
            file_name: '',
        }
    },
    computed: {
        canSubmit
    },

    created() {
        this.$root.$on('sidebar-open-edit-contract-generation', async (payload) => {            
            this.clearForm()

            if(payload.id){
                this.form.id = payload.id
                this.previousData = payload
                this.file_name  = getFileExtension(payload.files)
                
                await this.loadForm(payload, {...payload.visibility})
            }
        })
    },

    beforeDestroy() {
        this.$root.$off('sidebar-open-edit-contract-generation')
    },

    methods: {
        sidebarDefaultReset,

        /**
         * Limpa os dados do formulário e inicializa com os valores padrões
         */
        clearForm() {
            this.form = { ...defaultFormData() }
            this.sidebarDefaultReset()
        },

        /**
         * Faz o upload do arquivo via form data para receber o ID
         */
        async fileUpload() {
            const element   = document.getElementById('sidebar-edit-upload' + this.componentID)
            const file      = element.files[0]
            const fileData  = new FormData()

            fileData.append('file', file)

            /**
             * Verifica se tem um arquivo sendo carregado
             */
            if (typeof file == 'object') {
                this.fileUploadLoading      = true
            } else {
                /* Limpa o arquivo quando o usuario cancela o upload  */
                this.form.data.file_id      = 0
                this.fileUploadLoading      = false
            }

            await files
                .create('', fileData)
                .then((response) => {
                    if (this.form.data.file_id != undefined && response.data[0] != undefined && response.data[0].file != undefined) {
                        this.form.data.file_id  = response.data[0].file.id
                    }
                    this.fileUploadLoading      = false
                    this.mensage = ''
                })
                .catch((error) => {
                    this.mensage                = 'O arquivo anexado não é compatível'
                    this.productLoading         = false
                    console.error(error) 
                })
        },
        /**
         * Abre o modal com o formulário de criação dos campos dinâmicos
         */
        addFields() {
            this.$root.$emit('popup-open-add-fields')
        },
        getSearchData(){
            if (this.searchData) {
                this.searchInputValue = this.searchData
            }
        },

        /**
         * Carrega os dados do formulário
         */
        async loadForm(payload, visibility) {
            this.optionsLoading = true
            this.loadText = "Carregando"

            this.form.data.name = payload.name

            try {
                const response = await product.getProductOptions()
                this.options.products = [...response.data]

                this.form.data.visibility.products = [...visibility.products]
                this.productLoading = false
            } catch(err){
                this.$toastr.e(err.data.msg)
                this.productLoading = false
            }

            try {
                const response = await funnel.getStages()
                let stagesList = response.data
                let stageTypedList = []

                stagesList.forEach(stage => {
                    stageTypedList.push({ 
                    label: stage.name, 
                    value: stage.id, 
                    type: "Etapas do Sistema"
                    })
                })

                this.options.stage = [...stageTypedList]
                this.funnelStageOptions = [...stagesList]
                this.form.data.visibility.stage = [...visibility.stage]

                this.stageInputHandler()
                this.form.data.visibility.status = [...visibility.status]
            } catch(err){
                this.$toastr.e(err.data.msg)
            }

            this.form.data.empty = payload.empty
            this.form.data.file_id = this.previousData.file_id

            setTimeout(()=> {
                this.optionsLoading = false
            }, 1200)
        },

        selectedStagesHaveStatus(){
            let statusSteps = []

            this.form.data.visibility.stage.map((selectedStageID) => {
                const statusList      =   this.loadStageStatusOptions(selectedStageID)
                
                if (statusList && statusList.length){
                statusSteps.push(selectedStageID)
                }
            })

            return statusSteps.length > 0
        },

        /**
         * Envia os dados do formulário de modo a atualizar a instância
         */
        async submitForm() {
            /**
             * Emite o evento do Google Analytics
             */
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vuejs-gerar contrato",
                action: "click",
                label: "Contrato gerado",
            })

            if (this.canSubmit) {
                this.optionsLoading = true
                this.loadText = 'Salvando alterações'
                this.productLoading = true

                await contractGeneration.update('', this.previousData.id, this.form.data)
                    .then((response) => {
                        this.$toastr.s(response.data.msg)
                        this.optionsLoading = false
                        this.productLoading = false
                        this.$root.$emit("contract-generation", this.searchInputValue)
                        this.$root.$emit('sidebar-close-' + 'edit-contract-generation')
                    })
                    .catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.error(error)
                    })
            }
        },
        /**
         * Função retorna o nome da etapa com base no ID dela
         */
        getStageLabel(stageId) {
            const stage = this.options.stage.find(element => element.value === stageId)
            return stage ? stage.label : null
        },
        /**
         * Carrega o select de status de acordo com a etapa selecionada
         */
        loadStageStatusOptions(stageId) {
          const stage = Object.values(this.funnelStageOptions).find(stage => stage.id === parseInt(stageId))
          if (stage) return [...stage.status]
        },
        /**
         * Função chamada quando uma etapa é selecionada
         */
        stageInputHandler() {
            let statusFound = []
            let statusTypedList = []
            
            if (this.form.data.visibility.stage.length == 0) this.form.data.visibility.status = []
            
            /* Gera o grupo dos Status baseados na etapa  */
            this.form.data.visibility.stage.map((stageId) => {
                const statusList      =   this.loadStageStatusOptions(stageId)
                const stageLabel      =   this.getStageLabel(stageId)
                let   statusGroup     =   { title: stageLabel, items: [] }

                if (statusList && statusList.length)
                    statusGroup.items = statusList.map(
                        status => ({ label: status.name, value: status.id, type: stageLabel })
                    )
            
                statusTypedList = [ ...statusTypedList, ...statusGroup.items ]
            })

            /* Verifica se o stage do status esta selecionado  */  
            this.form.data.visibility.stage.map((stageId) => {
                const statusList      =   this.loadStageStatusOptions(stageId)
                if (statusList && statusList.length) {
                    statusList.map((status) => {
                        if(this.form.data.visibility.status.indexOf(status.id) != -1){
                            statusFound.push(status.id)
                        }
                    })
                }
            })
            
            this.form.data.visibility.status = statusFound
            this.options.status = [...statusTypedList]
        },
        /**
         * Carrega select de campos de acordo com o grupo de campos selecionado
         */
        loadGroupFieldOptions(groupId) {
            this.groupFieldLoading  = true
            this.groupFieldOptions  = []

            const group = Object.values(this.fieldGroupOptions).find(group => group.id === parseInt(groupId))

            if (group) this.groupFieldOptions = [...group.fields]
            this.groupFieldLoading  = false
        },
        /**
         * Função chamada quando um grupo de campos é selecionado
         */
        fieldGroupInputHandler(groupId) {
            this.groupFieldSelected = null
            this.loadGroupFieldOptions(groupId)
        },
        /**
         * ! Adiciona um novo campo dinâmico de acordo com o grupo de campos e
         * ! campo selecionado (Não está sendo usado para os Contratos)
         */
        addCustomField() {
            if (this.groupFieldSelected &&
                this.groupFieldSelected !== null &&
                this.fieldGroupSelected &&
                this.fieldGroupSelected !== null) {
                this.customFieldsComputed = {
                    field_group_id: this.fieldGroupSelected,
                    field_id: this.groupFieldSelected
                }
                this.fieldGroupSelected = null

                this.fieldGroupInputHandler(null)
                this.$root.$emit('popup-close-add-fields')
            }
        },
        /**
         * ! Remove um campo dinâmico (Não está sendo usado para os Contratos)
         */
        deleteCustomField(key) {
            this.$delete(this.form.custom_fields, key)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>